import React from 'react';
import { Link } from 'react-router-dom';
import { ConfigurationSection, SpaceBetweenRow } from "@features/settings/pages/StyleComponents";
import { BodyLarge, BodyRegular } from "../../atoms/fonts/Body";
import { SimpleSpinner } from "../../atoms/SimpleSpinner";
import { Switch } from "../../atoms/Switch";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { selectConfig, selectIsConfigLoading, updateConfig } from '@shared/store/config.duck';
import { selectCurrentUser, selectIsInTeams } from '@shared/store/auth.duck';
import { AccountType } from '@shared/models/company.models';
import { Column } from "../../atoms/StructuralLayout";
import Colours from "../../atoms/Colours";

export function VisitorBookingSettings() {
  const dispatch = useDispatch();
  const config = useSelector(selectConfig);
  const isLoading = useSelector(selectIsConfigLoading);
  const user = useSelector(selectCurrentUser);
  const isInTeams = useSelector(selectIsInTeams);
  const {t} = useTranslation();

  const accountType = user?.companyEntity.accountType;
  const isTierRestricted = accountType === AccountType.STANDARD || accountType === AccountType.PROFESSIONAL;

  const onChange = (enabled: boolean) => {
    if (!config) return;
    dispatch(updateConfig({
      ...config,
      visitorBookingEnabled: enabled,
    }));
  }

  return (
    <ConfigurationSection style={{marginTop: 32, marginBottom: 48}}>
      <SpaceBetweenRow style={{marginBottom: 2}}>
        <Column>
          <BodyLarge colour={Colours.blue}>{t('settings.visitor-booking.title')}</BodyLarge>
          {isTierRestricted && (
            isInTeams
              ? <BodyRegular style={{marginTop: 4, color: Colours.darkGrey}}>
                  {t('settings.visitor-booking.not-enabled')}{' '}
                  <a href="mailto:support@team-today.com">support@team-today.com</a>
                </BodyRegular>
              : <BodyRegular style={{marginTop: 4, color: Colours.darkGrey}}>
                  {t('settings.visitor-booking.upsell')}{' '}
                  <Link to="/manage/payments">{t('settings.visitor-booking.upsell-link')}</Link>
                </BodyRegular>
          )}
        </Column>
        {isLoading ? <SimpleSpinner size={32} /> : <Switch value={!!config.visitorBookingEnabled} label=""
                                                           disabled={isLoading || isTierRestricted}
                                                           onChange={(val: boolean) => onChange(val)}/>}
      </SpaceBetweenRow>
    </ConfigurationSection>
  )
}
